export default __webpack_public_path__ + "static/media/tip2Right.0bb91699.png";